import React from 'react'

export const WithdrawSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.01807 9.87109H9.35273'
        stroke='currentColor'
        stroke-width='0.852378'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.66553 1.89062L8.70584 7.93094'
        stroke='currentColor'
        stroke-width='0.852378'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.66553 6.32162V1.89062H7.09653'
        stroke='currentColor'
        stroke-width='0.852378'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
